import { API } from "../api/api";
import type { ApiProduct, Product } from "../types";

const toOptionalNumber = (value: string | number | null | undefined) => {
  if (value === null || value === undefined || value === "") return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const normalizeProduct = (product: ApiProduct): Product => ({
  ...product,
  price: Number(product.price),
  rating: toOptionalNumber(product.rating),
});

export const fetchProducts = async (): Promise<Product[]> => {
  const { data } = await API.get<ApiProduct[]>("/products");
  // O "Monte seu Lanche" tem página própria; o backend novo já não manda, mas garantimos aqui.
  return data.filter((p) => !p.is_builder).map(normalizeProduct);
};
